export default __webpack_public_path__ + "static/media/anonymized.0c3c89a9.svg";